import { Tag, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import { PresetColors } from "../../../../../../common/constants";
import { AgentCompetenceLevel } from "../../../../../agent/enums";

const getColor = (level: AgentCompetenceLevel) => {
  switch (level) {
    case AgentCompetenceLevel.MIDDLE:
      return PresetColors.GEEKBLUE;
    case AgentCompetenceLevel.HIGHER:
      return PresetColors.ORANGE;
    case AgentCompetenceLevel.HIGHEST:
      return PresetColors.GOLD;
    default:
      return PresetColors.PROCESSING;
  }
};

type Props = {
  level: AgentCompetenceLevel;
};

export const AgentCompetenceLevelTag = ({ level }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t(`agent.competence.helpers.competenceLevel.${level}`)}>
      <Tag style={{ cursor: "pointer" }} color={getColor(level)} variant="filled">
        {t(`agent.competence.enums.competenceLevel.${level}`)} <AntIcon type="rise" />
      </Tag>
    </Tooltip>
  );
};
